import moment from "moment-timezone";

declare module "moment-timezone" {
  interface Moment {
    toPBString(): string;
  }
}

moment.fn.toPBString = function (): string {
  return this.utc().format("YYYY-MM-DD HH:mm:ss.SSS") + "Z";
};

// Function to dynamically change the default timezone
const setTimezone = (timezone: string) => {
  console.log(`Setting timezone to ${timezone}`);
  moment.tz.setDefault(timezone);
};

/**
 * 
 * @param date 
 * @param format 
 * @param timezone 
 * @returns 
 */
const formatTime = (
  date: string | Date, 
  format: string = 'DD-MM-YYYY HH:mm:ss', 
  timezone?: string):string => {
  if (!timezone) {
    return moment(date).format(format)
  }
  return moment(date).tz(timezone).format(format);
};

/**
 * 
 * @param format 
 * @param timezone 
 * @returns 
 */
const getCurrentTime = (
  format: string = 'DD-MM-YYYY HH:mm:ss',
  timezone?: string
): string => {
  if (!timezone) {
    return moment().format(format);
  }
  return moment().tz(timezone).format(format);
};

/**
 * 
 * @param date 
 * @param timezone 
 * @returns 
 */
const toTimezoneDate = (
  date: string | Date,
  timezone?: string
): Date => {
  if (!timezone) {
    return moment(date).toDate();
  }
  return moment(date).tz(timezone).toDate();
};

// Export the moment instance and the timezone setter
export { formatTime, getCurrentTime, moment, setTimezone, toTimezoneDate };

